import type { Period } from '@/utils/analytics'
import { PERIOD_OPTIONS } from '@/utils/analytics'

interface PeriodSelectorProps {
  period: Period
  onChange: (period: Period) => void
}

export default function PeriodSelector({ period, onChange }: PeriodSelectorProps) {
  return (
    <div
      role="tablist"
      aria-label="Date range"
      className="inline-flex bg-[var(--bg-secondary)] border border-[var(--border)] rounded-lg p-1"
    >
      {PERIOD_OPTIONS.map(opt => {
        const active = opt.id === period
        return (
          <button
            key={opt.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.id)}
            className={
              'px-3 py-1.5 text-sm rounded-md transition-colors cursor-pointer ' +
              (active
                ? 'bg-[var(--accent-teal)] text-[var(--bg-primary)] font-semibold'
                : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]')
            }
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
